import { render } from "./ControlHome.vue?vue&type=template&id=137d15c6&scoped=true&ts=true&lang=pug"
import script from "./ControlHome.vue?vue&type=script&lang=ts"
export * from "./ControlHome.vue?vue&type=script&lang=ts"

import "./ControlHome.vue?vue&type=style&index=0&id=137d15c6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137d15c6"]])

export default __exports__